import { FC } from 'react';
import { SimpleTooltip } from '@ygtechnologies/rubus-ui';
import theme from './OptionGroupLabel.module.scss';

interface OptionGroupLabelProps {
    name: string;
    /** Internal note shown only to sellers/admins, never to buyers. */
    internalNote?: string | null;
    className?: string;
}

/**
 * Renders an option group's name followed by its internal note in parentheses,
 * e.g. "Kitchen (units 101-115, premium)". The note truncates with an ellipsis when
 * long and shows the full text on hover. Seller-side only.
 */
const OptionGroupLabel: FC<OptionGroupLabelProps> = ({ name, internalNote, className }) => {
    const trimmedNote = internalNote?.trim();
    return (
        <span className={[theme.root, className].filter(Boolean).join(' ')}>
            {name}
            {trimmedNote && (
                <SimpleTooltip content={trimmedNote}>
                    <span className={theme.note}>
                        (<span className={theme.noteText}>{trimmedNote}</span>)
                    </span>
                </SimpleTooltip>
            )}
        </span>
    );
};

export default OptionGroupLabel;
